import axios, { AxiosError } from "axios";
import {
  COMMON_STRINGS,
  AUTH_STRINGS,
} from "../constants/strings";
import { ENV } from "../config/env";

// 🔐 Base URL
const BASE_URL = ENV.API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
});

// ================= REQUEST INTERCEPTOR =================

// 🔐 Attach token
axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      const token = localStorage.getItem("admin_token");

      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    } catch (error) {
      console.error("Request Interceptor Error:", error);
      return config;
    }
  },
  (error) => Promise.reject(error)
);

// ================= RESPONSE INTERCEPTOR =================

axiosInstance.interceptors.response.use(
  (response) => response,

  (error: AxiosError<any>) => {
    const status = error.response?.status;
    const serverMessage = error.response?.data?.message;
    const shouldLogout = error.response?.data?.logout;

    // 🔥 FORCE LOGOUT CASE (ADMIN SECURITY)
    if (status === 403 && shouldLogout) {
      console.warn("🚫 Forced logout triggered");

      // clear token
      localStorage.removeItem("admin_token");

      // redirect to login
      window.location.href = "/login";

      return Promise.reject({
        success: false,
        message: "Unauthorized admin access",
        status,
      });
    }

    // 🔥 Default message
    let finalMessage =
      serverMessage || COMMON_STRINGS.SERVER_ERROR;

    // 🔐 Unauthorized
    if (status === 401) {
      finalMessage = COMMON_STRINGS.UNAUTHORIZED;

      // optional auto logout
      localStorage.removeItem("admin_token");
      window.location.href = "/login";
    }

    // 🚫 Forbidden (normal case)
    if (status === 403) {
      finalMessage = COMMON_STRINGS.FORBIDDEN;
    }

    // ❌ Not found
    if (status === 404) {
      finalMessage = COMMON_STRINGS.NOT_FOUND;
    }

    // ⚠️ Server error
    if (status === 500) {
      finalMessage = COMMON_STRINGS.SERVER_ERROR;
    }

    // 🌐 Network error
    if (!error.response) {
      finalMessage = COMMON_STRINGS.NETWORK_ERROR;
    }

    return Promise.reject({
      success: false,
      message: finalMessage,
      status,
      originalError: error,
    });
  }
);

export default axiosInstance;